__turbopack_context__.v({
  "benefit": "TrYV-a_benefit",
  "benefitIcon": "TrYV-a_benefitIcon",
  "benefits": "TrYV-a_benefits",
});
